import React, { useMemo, useState } from "react";
import { steps } from "./todoConstant";
import AccordionTodo from "./Accordian";

const TodoSteps = React.memo(({ cards, scrollToCardId, height }) => {
  const haveOpenCards = cards?.filter(
    (card) => card.card.todo_column === steps[0].name
  );
  const [expanded, setExpanded] = useState(
    haveOpenCards?.length && steps[0].name
  );

  const isHideAccepted = cards.filter(
    (card) => card.card.todo_column === "Accepted"
  )?.length;

  const stepInfo = useMemo(() => {
    return steps.reduce((acc, step) => {
      const stepCards = cards.filter(
        (card) => card.card.todo_column === step.name
      );
      acc[step.name] = {
        hasCards: stepCards.length > 0,
        cardCount: stepCards.length,
      };
      return acc;
    }, {});
  }, [cards]);

  const handleAccordionChange = (val) => {
    setExpanded((prev) => (val === prev ? "" : val));
  };

  return (
    <div style={{ marginTop: "-6px" }}>
      {steps.map((step, idx) => (
        <AccordionTodo
          key={idx}
          heading={step.name}
          uniqueKey={idx}
          expanded={expanded}
          scrollToCardId={scrollToCardId}
          stepInfo={stepInfo}
          onChange={handleAccordionChange}
          cards={cards.filter((card) => card.card.todo_column === step.name)}
          sx={
            step.name === "Completed" && !isHideAccepted
              ? { ...step.sx, bottom: "0px" }
              : step.sx
          }
          height={height}
        />
      ))}
    </div>
  );
});

export default TodoSteps;
